<template>
  <div class="centered">
    <!-- Show loading spinner if loading -->
    <LoadingComponent v-if="isLoading" />
    <!-- Show convenience fee message -->
    <ConvenienceFeeMessageComponent />
    <div class="row custom-amount-container">
      <div class="cell">
        <label
          v-if="showCreditCardLimitDisclaimer()"
          for="pay-amount"
        >Amount (${{ invoice.remaing_digital_wallet_amount }} limit)</label>
        <label
          v-else
          for="pay-amount"
        >Amount</label>
        <input
          id="pay-amount"
          v-model="customAmount"
          class="input amount-input"
          name="pay-amount"
          type="number"
          @change="customAmountChanged"
        >
        <label
          v-if="showCreditCardLimitDisclaimer()"
          class="amount-disclaimer"
        >Credit Card and digital wallets are limited to $15,000. Balance will be due by Zelle, ACH, or Wire Transfer.</label>
      </div>
    </div>
    <!-- Show paypal button -->
    <div
      v-show="isLoading === false && !error"
      id="paypal-button-container"
    />
    <!-- Show error -->
    <BraintreeErrorMessageComponent
      v-if="error"
      :error="error"
    />
    <!-- End PayPal component -->
  </div>
</template>
<script>
import BraintreeError from '../../../../errors/BraintreeError'
import BraintreeErrorMessageComponent from '../../Shared/BraintreeErrorMessageComponent.vue'
import LoadingComponent from '../../Shared/LoadingComponent.vue'
import ConvenienceFeeMessageComponent from '../../Shared/ConvenienceFeeMessageComponent.vue'
export default {
  name: 'PayPalComponent',
  components: {
    BraintreeErrorMessageComponent,
    LoadingComponent,
    ConvenienceFeeMessageComponent
  },
  props: ['braintreeInstance', 'invoice', 'disablePaymentMethod', 'deviceData'],
  data: function () {
    return {
      isLoading: true,
      error: null,
      customAmount: 0,
    }
  },
  computed: {
    amount: function () {
      const balance = this.invoice.invoice_balance
      return balance.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    paymentFormStore () {
      return this.$store.getters.paymentForm
    }
  },
  created () {
    this.init()
  },
  methods: {
    /**
     * Init the google pay button
     */
    init: function () {
      // Create a PayPal Checkout component.
      let self = this
      if(this.invoice !== undefined){
        this.customAmount = this.invoice.remaing_digital_wallet_amount ? this.invoice.remaing_digital_wallet_amount.toFixed(2) : 0
      }
      window.braintree.paypalCheckout.create(
        {
          client: this.braintreeInstance
        },
        (paypalCheckoutErr, paypalCheckoutInstance) => {
          this.isLoading = false
          // Stop if there was a problem creating PayPal Checkout.
          // This could happen if there was a network error or if it's incorrectly
          // configured.
          if (paypalCheckoutErr) {
            const exception = new BraintreeError(paypalCheckoutErr)
            this.error = exception.getMessage()
            return
          }
          paypalCheckoutInstance.loadPayPalSDK((loadSDKErr) => {
            if (loadSDKErr) {
              const exception = new BraintreeError(loadSDKErr)
              this.error = exception.getMessage()
              return
            }

            // The PayPal script is now loaded on the page and
            // window.paypal.Buttons is now available to use
            // render the PayPal button (see Render the PayPal Button section)
            window.paypal
              .Buttons({
                fundingSource: window.paypal.FUNDING.PAYPAL,
                createOrder: () => {
                  return paypalCheckoutInstance.createPayment({
                    flow: 'checkout', // Required
                    amount: this.customAmount, // Required
                    currency: 'USD' // Required, must match the currency passed in with loadPayPalSDK
                  })
                },
                onApprove: function (data, actions) {
                  return paypalCheckoutInstance.tokenizePayment(
                    data,
                    function (err, payload) {
                      // Submit 'payload.nonce' to your server
                      if (err) {
                        const exception = new BraintreeError(err)
                        self.error = exception.getMessage()
                        return
                      }

                      const {nonce} = payload
                      const paymentForm = {
                        nonce: nonce,
                        type: 'paypal',
                        submitCC: false,
                        deviceData: self.deviceData,
                        isPartialPayment: self.invoice.invoice_balance == self.customAmount ? false : true,
                        amount: self.customAmount,
                        savedPaymentMethod: false
                      }

                      self.$store.dispatch('updatePaymentForm', paymentForm)
                    }
                  )
                },

                onCancel: function (data) {
                  console.log(
                    'PayPal payment cancelled',
                    JSON.stringify(data, 0, 2)
                  )
                },
                onError: (err) => {
                  const exception = new BraintreeError(err)
                  this.error = exception.getMessage()
                }
              })
              .render('#paypal-button-container')
          })
        }
      )
    },
    customAmountChanged: function (event) {
      const current = event.target.value
      const amount = parseFloat(current)
      if(amount > this.invoice.remaing_digital_wallet_amount){
        this.customAmount = this.invoice.remaing_digital_wallet_amount
      }
      else{
        this.customAmount = amount
      }
    },
    showCreditCardLimitDisclaimer: function () {
      return this.invoice.invoice_total > 15000
    },
    /**
     * To force a payment method to be hidden from list.
     */
    disable: function () {
      this.disablePaymentMethod(this.$options.name)
    }
  }
}
</script>
<style scoped>
#paypal-button-container {
  margin-top: 1em;
  width: 300px;
}
.amount-input {
  margin-bottom: 0;
}
.amount-input {
  margin-bottom: 0;
}
.centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
}

.custom-amount-container {
  max-width: 300px;
  width: 100%;
}

.amount-disclaimer {
  text-align: center;
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  font-size: 0.8em;
}
</style>
